import {httpPost} from "../../api/http-functions";
import {withLazyDynamicTable} from "../ui/hoc/LazyDynamicTable";
import {useTranslation} from "react-i18next";
import React, {Fragment, useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {TableLoadingRow} from "../ui/table/TableLoadingRow";
import {TableEmptyRow} from "../ui/table/TableEmptyRow";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {MachineTagsManagementAction} from "./shared/machine-actions/MachineTagsManagementAction";
import {MachineRenameAction} from "./shared/machine-actions/MachineRenameAction";
import {MachineResetAction} from "./shared/machine-actions/MachineResetAction";
import {MachineContactsManagementAction} from "./shared/machine-actions/MachineContactsManagementAction";
import {ActionsMenu} from "../ui/ActionsMenu";
import MachineAvatar from "./shared/MachineAvatar";
import {Typography} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import {searchOrganizationMachines} from "../../api/machine-functions";
import Button from "@material-ui/core/Button";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {useNavigate} from "react-router-dom";
import {ChipBackgroundColors, ChipTextColors} from "../../layout/_constants";
import {MoveMachineAction} from "./shared/machine-actions/MoveMachineAction";
import {run} from "../../utils/function-util";
import {Machine} from "../../models/machine.models";

export const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 100,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    spinner: {
        position: 'absolute',
        left: '50%'
    }
}));

const MachineDataRow = (props: any) => {
    const {
        friendlyName,
        organizationId,
        organizationName,
        organizationUnitName,
        organizationUnitId,
        email,
        label,
        version,
        tags,
        isActive,
        isExpired,
        actions
    } = props
    const navigate = useNavigate();
    const {t} = useTranslation();

    const goToUnit = async () => {
        navigate(`/organization-units/${organizationUnitId}/detail?tab=1&organizationId=${organizationId}`);
    };

    const goToOrg = async () => {
        navigate(`/organization-units?organizationId=${organizationId}`);
    }


    return (
        <TableRow>
            <TableCell component="th" scope="row"> <MachineAvatar/> </TableCell>
            <TableCell>
                <Typography variant="body1">{friendlyName}</Typography>
                <Typography variant="body2"
                            color={'textPrimary'}>{email}</Typography>
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{(version && !label) ? t('Machine.UCVersion.Unknown') : label}</Typography>
                <Typography variant="body2"
                            color={'textPrimary'}>{version}</Typography>
    </TableCell>
            <TableCell>
                {
                    isActive ?
                        isExpired ?
                            <Chip color='primary' style={{backgroundColor: ChipBackgroundColors.Expired}}
                                  label={t('Machine.SubscriptionStatus.Expired')}/>
                            : <Chip color='primary'
                                    style={{backgroundColor: ChipBackgroundColors.Active, color: ChipTextColors.Active}}
                                    label={t('Machine.SubscriptionStatus.Active')}/>
                        : <Chip color='primary' style={{
                            backgroundColor: ChipBackgroundColors.NonActive,
                            color: ChipTextColors.NonActive
                        }}
                                label={t('Machine.SubscriptionStatus.NonActive')}/>
                }
            </TableCell>
            <TableCell>
                <Button onClick={goToOrg}><Typography variant="body1">{organizationName}</Typography></Button>
            </TableCell>
            <TableCell>
                <Button onClick={goToUnit}>
                    <Breadcrumbs>
                        <Typography variant="body1">
                            {`../${organizationUnitName}`}
                        </Typography>
                    </Breadcrumbs>
                </Button>
            </TableCell>
            <TableCell>
                {tags.map((tag: any) => <Chip color='primary' key={tag.key} label={tag.key} title={tag.value}
                                            style={{margin: '2px'}}/>)}
            </TableCell>
            <TableCell align="center">
                {actions}
            </TableCell>
        </TableRow>
    );
};


const _Machines = ({
                       loading,
                       data: machines,
                       onDataItemUpdated,
                       actions = null,
                       handleChange,
                       ...props
                   }: any) => {
    const {t} = useTranslation();

    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.MachineName')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.UCVersion.Title')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.SubscriptionStatus.Title')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.Organization')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.OrganizationUnit')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.Tags')}
                        </label>
                    </TableCell>
                    <TableCell style={{width: "50px"}} align="center">
                        <label>
                            {t(`Machine.Actions.Title`)}
                        </label>
                    </TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    loading ?
                        <TableLoadingRow colSpan={4}/> :
                        machines.length === 0 ?
                            <TableEmptyRow messageKey={'Machine.NoMachines'}/> :
                            machines.map((m: Machine) => <MachineDataRow
                                key={`${m.id}-${m.organizationUnitName}`}
                                {...props}
                                {...m}
                                actions={
                                    actions ? actions(m) :
                                        <ActionsMenu>
                                            {(onClose: any) => <>
                                                <MachineContactsManagementAction {...m} />
                                                <MachineTagsManagementAction {...m} />
                                                <MachineRenameAction {...m}
                                                                     onRenamed={(friendlyName: string) => {
                                                                         onDataItemUpdated({
                                                                             ...m,
                                                                             friendlyName
                                                                         }, (e: any) => e.id === m.id);
                                                                         onClose();
                                                                     }}
                                                                     onCancel={onClose}
                                                />
                                                <MachineResetAction {...m}
                                                                    onActionCompleted={onClose}/>
                                                <MoveMachineAction organizationId={m.organizationId}
                                                                   machine={m}
                                                                   onMoved={handleChange}
                                                                   onActionCompleted={onClose}/>
                                            </>}
                                        </ActionsMenu>}

                            />)
                }
            </TableBody>
        </Fragment>
    );
}

export const Machines = (props: any) => {
    const {organizationId, actionForAll} = props;
    const [refresh, setRefresh] = useState(0);

    useEffect(run(Promise.resolve(), () => setRefresh(r => r + 1)), [organizationId])

    const query = ({
                       page,
                       size,
                       filter
                   }: any) => {
        const search = searchOrganizationMachines(httpPost);
        return search({organizationId, size, page, filter});
    };

    const handleChange = () => {
        setRefresh(r => r + 1);
    }

    return withLazyDynamicTable(_Machines, query, [], actionForAll)({...props, refresh, handleChange});
};
